export default __webpack_public_path__ + "static/media/921082.52aacba2.svg";